function normalizeQueryValue(value) {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }
  return String(value);
}

export function buildFilterQuery(filters) {
  const query = {};
  Object.entries(filters).forEach(([key, value]) => {
    const normalized = normalizeQueryValue(value);
    if (normalized !== undefined) {
      query[key] = normalized;
    }
  });
  return query;
}

export function syncRouteQuery(router, route, filters) {
  const query = buildFilterQuery(filters);
  const current = route.query || {};
  const keys = new Set([...Object.keys(query), ...Object.keys(current)]);

  const changed = [...keys].some(
    key => normalizeQueryValue(query[key]) !== normalizeQueryValue(current[key])
  );

  if (changed) {
    router.replace({ path: route.path, query }).catch(() => {});
  }
}
